// removed by extract-text-webpack-plugin
module.exports = {"wrapper-page-not-found":"magazines_27Khg","wrapper-page-not-found__bubble":"magazines_3NrdI","wrapper-page-not-found__message":"magazines_22Vz5","wrapper-page-not-found__person":"magazines_2wYl2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PageNotFound/styles.scss
// module id = 1265
// module chunks = 1